import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRoFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_53790)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M16.6677 41.3788H0.863086C0.387012 41.3788 0.000976562 40.9928 0.000976562 40.5167V9.48223C0.000976562 9.00615 0.387012 8.62012 0.863086 8.62012H16.6677V41.3788Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M33.335 8.62109H16.668V41.3799H33.335V8.62109Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.1386 41.3787H33.334V8.62012H49.1386C49.6146 8.62012 50.0007 9.00615 50.0007 9.48223V40.5167C50.0007 40.9929 49.6146 41.3787 49.1386 41.3787Z",
					fill: "#CD343C"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_53790",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgRoFlag);
export { ForwardRef as ReactComponent };
